<template>
  <div class="mask">
    <div class="maskA">
      <div class="maskAA">
        <p>{{$utils.getShowYear()}}年院校优先优化志愿生成表</p>
        <img @click="Tijiaog()" src="../../src/assets/img/cha.png" />
      </div>
      <div class="zhiyuaninfo" v-if="tianbaoType!=0">
        <div class="num yixuan">已选志愿 ( {{yixuan.length}} )</div>
        <div class="num cyc">冲 ( {{cyc.ids.length}} )</div>
        <div class="num wyw">稳 ( {{wyw.ids.length}} )</div>
        <div class="num byb">保 ( {{byb.ids.length}} )</div>
        <div class="num dyd">垫 ( {{dyd.ids.length}} )</div>
      </div>
      <div class="zhiyuaninfo" v-else>
        <div class="num yixuan">已选志愿 ( {{yixuan.length}} )</div>
        <div class="num cyc">冲 ( {{allNum.cyc}} )</div>
        <div class="num wyw">稳 ( {{allNum.wyw}} )</div>
        <div class="num byb">保 ( {{allNum.byb}} )</div>
        <div class="num dyd">垫 ( {{allNum.dyd}} )</div>
      </div>

      <div class="mask_nr">
        <div class="ANAN1">
          <ul class="generateList">
            <li v-for="(item,index) in yixuan" :key="index">
              <div class="xh"  :style="$utils.getrateStyle(map[item].rate,1)">{{index+1}}</div>
              <div class="item clomxia">
                <div class="itemLeft flex-items" >
                  <div class="t1"  v-if="map[item].score!=null&&map[item].score.length!=0">
                    <span :style="$utils.getrateStyle(map[item].rate)">{{map[item].rate}}%</span>
                    <h5 :style="$utils.getrateStyle(map[item].rate)">概率</h5>
                  </div>
                  <div class="t1" v-else>
                    <div style="width: 55px;color: #F53824;line-height: 24px; font-size: 12px;">新增专业不做推荐自主填报</div>
                  </div>
                  <div class="t2">
                    <h4 style="font-size: 16px;width: 550px;display: flex;justify-content: start;">
                      <span class="myspan" v-if="$utils.getlocalStorage('showcode')"
                      style="border: 1px solid #F53824;background-color: white;border-radius: 18px;
                      padding: 0px 10px;font-size: 12px;margin-right: 10px;">
                        {{getempty(map[item].collegeCode)}}
                      </span>
                      {{map[item].collegeName}}
                      <span v-if="map[item].collegeInfo!=null&&map[item].collegeInfo!=''"
                        style="margin-left:10px;">{{map[item].collegeInfo}}</span>
                        <div style="margin-left: 10px;">
                            <icollege :item="map[item]"></icollege>
                        </div>
                      <div class="itemRigth " style="margin-left: auto;">
                        <div class="flex-items shipei">
                          <span class="del" style="font-size: 12px; width: 80px;height: 20px;" @click="del(index,item,map[item].type)">删除志愿</span>
                        </div>
                      </div>
                    </h4>

                    <!-- <span style="float: right;color: #F53824;margin-right: 10px;"
                       v-if="tianbaoType == 2">分组:{{map[item].groupname}}</span> -->

                    <div class="flex-items shipeishangxia" style="margin-top:5px;width: 550px;justify-content: start;">
                      <div class="dm" style="font-size: 12px;">
                        <span style="color: black;">{{AREA_OBJ[map[item].collegeArea]}} /
                        {{ map[item].collegeSubject }} /
                        <span :style="{color:map[item].collegeNature == 1?'':'red'}">{{map[item].collegeNature == 1?'公立':'民办'}}</span>
                        <span v-if="map[item].college!=null&&map[item].college.area!=null"> / {{ map[item].college.area }}</span>
                        </span>

                        <p>{{map[item].collegeNature !=1?'民办':''}}
                          {{map[item].collegeLevel!=null&&map[item].collegeLevel!=""?"/"+map[item].collegeLevel.replace(/,/g,'/'):''}}
                        </p>
                      </div>

                    </div>

                    <div class="flex-items shipeishangxia" v-if="tianbaoType == 1" style="width: 550px;">
                      <div class="dm">
                        <div v-if="tianbaoType == 2" style="background-color: #29A7E1;border-radius: 10px;height: 20px;padding: 0px 5px;margin-right: 5px;">
                          <span style="font-size: 12px;line-height: 20px;color: #ffffff;">{{map[item].groupName}}</span>
                        </div>
                        <div style="background-color: red;color: #ffffff;
                        height: 18px;line-height: 18px; font-size: 10px;padding: 0 5px;border-radius: 8px;margin-right: 10px;"
                        >{{map[item].majorCode}}</div>

                        <p style="margin-right:10px">
                          {{map[item].majorName}}
                        </p>
                        <p style="margin-right:10px; color:#F53824" v-if="map[item].studyMoney!=null&&map[item].studyMoney!=''">
                          学费 : {{map[item].studyMoney}}
                        </p>
                        <imajor :item="map[item]"></imajor>
                      </div>

                      <div style="margin-right: 125;font-size: 12px;">当年计划：<span
                          style="font-size:14px;color: #F53824;">{{getempty(map[item].planNum)}}</span>
                          <br/><span style="color: #F53824;">( {{map[item].xuankeStr}} )</span>
                          </div>
                    </div>
                    <div class="flex-items shipeishangxia" v-if="tianbaoType != 1" style="width: 550px;justify-content: start;font-size: 13px;line-height: 30px;">
                      <div>分组：<span style="color: #F53824;">{{map[item].groupname}}</span><span style="color: #666666;margin-left: 10px;">({{map[item].collegeInfo}}111)</span></div>
                      <div style="margin-left: 20px;">选科：<span style="color: #F53824;">{{map[item].xuankeStr}}</span></div>
                    </div>

                    <div class="flex-items majorinfo" style="width:550px" v-if="tianbaoType == 1">
                      <p class="info">{{map[item].majorInfo}}</p>
                    </div>
                  </div>
                  <yiscore  :score="map[item].score" :year="scoreYear" style="width: 395px;margin-left: 20px;"></yiscore>
                </div>


              </div>
              <div id="box" class="zhankaiNeirong" v-if="!map[item].show">
                <div class="zymajor" v-for="(major,index1) in map[item].list">
                  <div class="text">
                    <div class="t1" v-if="major.score!=null&&major.score.length!=0">
                      <span style="font-size: 18px;" :style="$utils.getrateStyle(major.rate)">{{major.rate}}%</span>
                      <h5>概率</h5>
                    </div>
                    <div class="t1" v-else>
                       <div style="width: 55px;color: #F53824;line-height: 24px; font-size: 12px;">新增专业不做推荐自主填报</div>
                    </div>
                  </div>
                  <div style="flex-direction: column;justify-content: center;">
                    <div class="topBox">
                      <div class=" flex-items" style="min-width: 370px;flex-direction: column;justify-content: space-evenly;align-items: flex-start;">
                        <div style="display: flex;flex-direction: row;
                        width: 400px;
                        align-items: center;justify-content: space-between;">
                          <h4>{{major.majorName}}</h4>
                          <imajor :item="major"></imajor>
                        </div>

                        <div>
                          <div style="flex-direction: row;display: flex; justify-content: space-between;width: 400px;">
                            <div style="margin-top: 10px;" v-if="$utils.getlocalStorage('showcode')">代码：<b style="color: #F53824;">{{getempty(major.majorCode)}}</b></div>
                            <div style="margin-top: 10px;" v-if="major.studyMoney!=null&&major.studyMoney!=null">学费：<b style="color: #F53824;">{{major.studyMoney}}</b></div>
                            <div style="margin-top: 10px;" >计划招生：<b style="color: #F53824;">{{getempty(major.planNum)}}</b></div>
                          </div>
                        </div>
                        <p style="width:400px;color: #999999;" v-if="major.majorInfo!=null&&major.majorInfo!=''">
                        {{major.majorInfo}}</p>
                      </div>
                      <!-- <div class="px">
                        <a href=""><img src="../views/images/s.png"></a>

                        <a href=""><img src="../views/images/x.png"></a>
                      </div> -->
                      <yiscore  :score="major.score" :year="scoreYear" style="width: 395px;margin-left: 20px;"></yiscore>
                      <div class="flex-end" style="justify-content: center;flex-direction: column;">
                        <span class="del" @click="delMajor(index,index1,item,map[item].type)">删除专业</span>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <span href="javascript:void(0)" v-if="tianbaoType != 1" class="zhankai"
                @click="openShutManager(map[item].id)">已选专业(<span>{{map[item].list.length}}</span>)个<img
                  src="../views/images/icon_xia.png"></span>
            </li>
          </ul>
        </div>
        <div class="dibudean">
          <div class="ansdhu" @click="tozyd">
            生成志愿单
          </div>
        </div>
      </div>
    </div>
<toast :title="title" :message="message" v-if="toastflag" @close="toastflag = false" @quxiao="quxiao" :fun="fun" :flag="toastflag" :btn="que"></toast>
  </div>
</template>

<script>
  import toast from './toast.vue'
  import yiscore from '../views/yiscore.vue'
  import icollege from '../components/icollege.vue'
  import imajor from '../components/imajor.vue'
  export default {
    components:{
      toast,
      yiscore,
      imajor,
      icollege
    },
    props: {
      scoreYear: Number
    },
    data() {
      return {
        yixuan: [],
        map: {},
        tianbaoType: this.$utils.getlocalStorage('tianbaoType'),
        AREA_OBJ: this.$utils.getlocalStorage("AREA_OBJ"),
        cyc: {},
        wyw: {},
        byb: {},
        dyd: {},
        allNum: {
          cyc: 0,
          wyw: 0,
          byb: 0,
          dyd: 0,
        },
        title: "",
        fun: 'quxiao',
        message: "",
        toastflag: false,
        que: 'que',
        tishi: 0,
        totype: "wyw",
      }
    },
    created() {
      console.log('yixuaninfo')
      this.cyc = this.$utils.getlocalStorage("ZhiYuancyc");
      this.wyw = this.$utils.getlocalStorage("ZhiYuanwyw");
      this.byb = this.$utils.getlocalStorage("ZhiYuanbyb");
      this.dyd = this.$utils.getlocalStorage("ZhiYuandyd");
      let a = {};
      let map = Object.assign(a,
        this.cyc.map,
        this.wyw.map,
        this.byb.map,
        this.dyd.map);
      let list = [];
      list = list.concat(this.cyc.ids)
      list = list.concat(this.wyw.ids)
      list = list.concat(this.byb.ids)
      list = list.concat(this.dyd.ids)
      list.sort(function(a,b){
        return map[a].rate-map[b].rate
      })
      this.yixuan = list
      this.map = map
      if (this.tianbaoType == 0) {
        this.getAllNum();
      }
    },
    methods: {
      getAllNum() {
        let _this = this;
        _this.allNum.cyc = 0;
        _this.allNum.wyw = 0;
        _this.allNum.byb = 0;
        _this.allNum.dyd = 0;
        for (let key in this.map) {
          let item = this.map[key]
          if (item.rate <= this.$rate.cyc) {
            _this.allNum.cyc++;
          } else if (item.rate >this.$rate.cyc && item.rate <= this.$rate.wyw) {
            _this.allNum.wyw++;
          } else if (item.rate > this.$rate.wyw && item.rate <= this.$rate.byb) {
            _this.allNum.byb++;
          } else if (item.rate > this.$rate.byb) {
            _this.allNum.dyd++;
          }
        }
      },
      quxiao() {
        if (this.tishi == 1) {
          this.tishi = 0
          if (this.tianbaoType != 0) {
            this.$emit("changetotype",this.totype) ;
          } else {
            this.Tijiaog()
          }
        }
        this.toastflag = false;
      },
      tozyd() {
        let opencent = this.$utils.getTinbaoAlert(null, null, 1);
        if (opencent) {
          this.title = opencent.title;
          this.fun = 'quxiao';
          this.message = opencent.content
          if (opencent.flag) {
            if (opencent.type == 2) {
              this.que = 'que,qu';
              this.totype = opencent.to
              this.toastflag = true;
              this.tishi = 1
            } else {
              this.que = 'que';
              this.toastflag = true;
            }
            //this.$emit("opentoast",opencent)
            return;
          }
        }
        let userZhiYuanBatch = this.$utils.getlocalStorage("userZhiYuanBatch");
        let scoreInfo = this.$utils.getlocalStorage("scoreInfo");

        this.$utils.setlocalStorage("ZhiYuanDanObj", {
          map: this.map,
          ids: this.yixuan,
          scoreYear:this.scoreYear,
          batchscore:userZhiYuanBatch.provincialScore,
          rank:scoreInfo.scoreRank
        });
        this.$router.push('/zyd')
      },
      del(index, id, type) {
        let map = this.$utils.getlocalStorage("ZhiYuan"+type)
        if (this[type].ids.indexOf(id) != -1) {
          this[type].ids.splice(this[type].ids.indexOf(id), 1);
          delete this[type].map[id]
        }
        this.yixuan.splice(this.yixuan.indexOf(id), 1)
        delete this.map[id]
        if (this.tianbaoType == 0) {
          this.getAllNum();
        }
        this.$utils.setlocalStorage("ZhiYuan"+type,this[type])

      },
      delMajor(index, index1, id, type) {
        this.map[id].ids.splice(index1, 1);
        this.map[id].list.splice(index1, 1);
        // this[type].map[id].ids.splice(index1,1);
        // this[type].map[id].list.splice(index1,1);
        console.log(this[type])
        if (this.map[id].list == 0) {
          this.yixuan.splice(this.yixuan.indexOf(id), 1)
          delete this.map[id]
          this[type].ids.splice(this[type].ids.indexOf(id), 1);
          delete this[type].map[id]
        }
        if (this.tianbaoType == 0) {
          this.getAllNum();
        }
      },
      Tijiaog() {
        this.$utils.setlocalStorage("ZhiYuancyc", this.cyc);
        this.$utils.setlocalStorage("ZhiYuanwyw", this.wyw);
        this.$utils.setlocalStorage("ZhiYuanbyb", this.byb);
        this.$utils.setlocalStorage("ZhiYuandyd", this.dyd);
        this.$emit("Tijiaog", {
          flag: false,
          cyc: this.cyc,
          wyw: this.wyw,
          byb: this.byb,
          dyd: this.dyd
        });
      },

      getempty(str){
        if(str==null||str == ''){
          return '--';
        }
        return str;
      },
      //===========================点击展开关闭效果====================================
      openShutManager(id) {
        this.map[id].show = !this.map[id].show
      },
    },
  }
</script>

<style>
  /* 遮罩层 查看专业遮罩层 ↓ */
  .mask {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 120;
    background-color: rgba(0, 0, 0, 0.7);
  }

  .majorinfo {
    margin-top: 5px;
  }

  .majorinfo .info {
    font-size: 12px;
    color: #999999 !important;
  }

  .majorinfo p {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 25px;
    color: #666666;
    margin-left: 0px !important;
  }

  .zhiyuaninfo {
    display: flex;
    flex-direction: row;
    /* margin-bottom: 10px; */
  }

  .zhiyuaninfo .num {
    /* width: 160px; */
    text-align: center;
    font-size: 14px;
    min-width: 100px;
    color: #FFFFFF;
    padding: 3px 15px;
    border-radius: 15px;
    margin-left: 20px;
  }


  .zhiyuaninfo .yixuan {
    background: linear-gradient(131deg, #FE9603 0%, #F53824 100%);
  }

  .zhiyuaninfo .cyc {
    background: #FF513E;
  }

  .zhiyuaninfo .wyw {
    background: #fe9b0e;
  }

  .zhiyuaninfo .byb {
    background: #0081cc;
  }

  .zhiyuaninfo .dyd {
    background: #00B54F;
  }


  .generateList {
    margin-bottom: 0px;
  }

  .maskA {
    width: 1100px;
    height: 90vh;
    background: rgb(255, 255, 255);
    border-radius: 20px;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
  }

  .maskAA {
    width: 1000px;
    height: 55px;
    background-image: url("../../src/assets/img/zzctop.png");
    background-size: 100% 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 28px;
    padding-left: 28px;
    box-sizing: border-box;
    margin-bottom: 10px;
  }

  .mask_nr {
    width: 100%;
    height: calc(100% - 64px);
    padding: 20px;
    padding-bottom: 0px;
    padding-top: 0px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    overflow: auto;
  }

  .maskAA img {
    width: 28px;
    height: 28px;
    cursor: pointer;
  }

  .ANAN {
    width: 100%;
    height: calc(100% - 64px);
  }

  .maskAA p {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }


  .maskAA {
    width: 100%;
  }

  .mask_nr {
    width: 100%;
    height: calc(100% - 180px);
  }

  .dibudean {
    cursor: pointer;
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 60px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px -1px 2px rgba(0, 0, 0, 0.05);
    opacity: 1;
  }

  .dibudean .ansdhu {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 160px;
    height: 46px;
    background: linear-gradient(131deg, #FE9603 0%, #F53824 100%);
    opacity: 1;
    border-radius: 5px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/yixuaninfo.vue